import { useEffect, useState } from "react"
import useAxiosInstance from '../../../../../Utilities/Hooks/useAxiosInstance';
import Form from "../../../../Partials/Layouts/Forms/Form"
import ShortTextInput from "../../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput"
import FormSubmitButton from "../../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton"
import { DISTRICT_API } from "../../../../../Utilities/APIs/APIs"

function UpdateDistrict({targetID, triggerFetch, setShowUpdateForm}) {

    const axiosInstance = useAxiosInstance()

    const [name, setTitle] = useState('')  
    const [division, setDivision] = useState('')   
    
    useEffect(() => {
        async function fetchAndSetSingleDistrict() {
          const { data } = await axiosInstance.get(DISTRICT_API + targetID)
          setTitle(data.name)
          setDivision(data.division)
        }
        fetchAndSetSingleDistrict()

      }, [targetID, axiosInstance])

    async function handleSubmit(e) {

        e.preventDefault()
        const itemData = new FormData()

        itemData.append('name', name)
        itemData.append('division', division)

        const response = await axiosInstance.patch(DISTRICT_API + targetID, itemData)
        if (response) {
            triggerFetch()
            setShowUpdateForm(false)
        }
    }

    return (
        <div className='crate_form'>
            <Form onSubmit={handleSubmit}>
                <div>
                <ShortTextInput
                        label={`Division`}
                        value={division}
                        placeholder={`Enter Division`}
                        setState={setDivision}
                    />
                    <ShortTextInput
                        label={`District`}
                        value={name}
                        placeholder={`Enter District`}
                        setState={setTitle}
                    />
                </div>
                <FormSubmitButton text="Submit" />
            </Form>
        </div>
    )
}

export default UpdateDistrict